export default __webpack_public_path__ + "static/media/home-travel-agency-destination-img06.057279c3.jpg";